import React from "react";
import { Box, Typography, Button } from "@mui/material";
import clsx from "clsx";
import FbIcon from "src/assets/images/settings/fblogo.png";
import useStyle from "../Styles";

interface NotConnectedBoxProps {
  openFacebookBuisnessLogin: () => void;
  handleOpenInstructions: () => void;
  isCollapsed?: boolean;
}

const NotConnectedBox: React.FC<NotConnectedBoxProps> = ({
  openFacebookBuisnessLogin,
  handleOpenInstructions,
  isCollapsed = false,
}) => {
  const { classes } = useStyle();

  return (
    <Box
      className={clsx(classes.cardWrapper, { collapsed: isCollapsed })}
      id="tour-facebook-card"
    >
      <Box className={clsx(classes.contentBox, { collapsed: isCollapsed })}>
        {/* Icon */}
        <Box
          className={clsx(classes.iconContainer, { collapsed: isCollapsed })}
        >
          <img src={FbIcon} alt="Facebook" className={classes.fbIcon} />
        </Box>

        {/* Text block */}
        <Box
          sx={{
            textAlign: isCollapsed ? "left" : "center",
            flex: isCollapsed ? 1 : "unset",
          }}
        >
          <Typography
            className={clsx(classes.mainTitle, { collapsed: isCollapsed })}
          >
            Facebook Messenger
          </Typography>
          <Typography
            className={clsx(classes.description, { collapsed: isCollapsed })}
          >
            Connect your Facebook pages to start managing customer conversations
            with precision and elite efficiency directly from Kuikwit.
          </Typography>
        </Box>

        {/* Actions */}
        <Box
          sx={{
            display: "flex",
            flexDirection: "column",
            alignItems: "center",
            gap: "12px",
          }}
        >
          <Button
            variant="contained"
            onClick={openFacebookBuisnessLogin}
            className={clsx(classes.connectBtn, { collapsed: isCollapsed })}
            id="tour-connect-button"
            disableElevation
          >
            CONNECT ACCOUNT
          </Button>

          {!isCollapsed && (
            <Button
              variant="text"
              onClick={handleOpenInstructions}
              className={classes.howItWorksBtn}
            >
              View Connection Guide
            </Button>
          )}
        </Box>
      </Box>
    </Box>
  );
};

export default NotConnectedBox;
